import { apiFetch } from './client';

// Getting-started checklist + achievements — mirrors
// internal/services/gettingstarted. The backend returns each milestone's key +
// flags + persisted unlock state; the SPA owns the display metadata (icon,
// title, CTA deep-link) keyed by `key`.

export interface Milestone {
  key: string;
  done: boolean;
  skipped: boolean;
  core: boolean;
  points: number;
  unlockedAt?: string;
}

export interface GrowthTier {
  key: string;
  threshold: number;
  points: number;
  earned: boolean;
  unlockedAt?: string;
}

export interface GrowthFamily {
  family: string;
  unit: 'count' | 'money_minor';
  current: number;
  tiers: GrowthTier[];
}

export interface GettingStartedProgress {
  milestones: Milestone[];
  growth: GrowthFamily[];
  coreDone: number;
  coreTotal: number;
  allCoreDone: boolean;
  pointsTotal: number;
  dismissed: boolean;
  celebrate: boolean;
  importing: boolean;
}

export async function getGettingStarted(
  token: string | null,
  slug: string,
): Promise<GettingStartedProgress> {
  return apiFetch<GettingStartedProgress>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/getting-started`,
    { method: 'GET', token },
  );
}

// Acknowledge the "club is live" celebration + mark earned achievements seen.
export async function markGettingStartedSeen(
  token: string | null,
  slug: string,
): Promise<void> {
  await apiFetch<void>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/getting-started/seen`,
    { method: 'POST', token },
  );
}

// Collapse the dashboard setup dialog (persisted per org).
export async function dismissGettingStarted(
  token: string | null,
  slug: string,
): Promise<void> {
  await apiFetch<void>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/getting-started/dismiss`,
    { method: 'POST', token },
  );
}

// Skip (or un-skip) a setup step so it no longer blocks the "club is live"
// milestone. Setup milestones only.
export async function skipGettingStartedStep(
  token: string | null,
  slug: string,
  key: string,
  skipped: boolean,
): Promise<void> {
  await apiFetch<void>(
    `/api/v1/organizations/${encodeURIComponent(slug)}/getting-started/skip`,
    { method: 'POST', token, body: { key, skipped } },
  );
}
